import {COLORS} from 'frontend/utils/color_palettes';
import {recloserSVG} from 'frontend/utils/icons';

import {AssetMapMarkerData, DefaultMapMarker, IconSize} from './default';

const RECLOSER_COLOR = COLORS.NewPrimary.get(40);

export interface RecloserMapMarkerData extends AssetMapMarkerData {
  color?: string;
}

/**
 * Map marker for a recloser asset.
 */
export class RecloserMapMarker extends DefaultMapMarker<RecloserMapMarkerData> {
  protected override getDefaultIcon(size: IconSize): string {
    return recloserSVG(this.data?.color ?? RECLOSER_COLOR, size);
  }
}
